<template>
  <post-detail v-if="post" :commonPost="post" :commonPosts="posts" @postsUpdated="onPostsUpdated" />
  <post-list v-else-if="posts" :commonPosts="posts" @postsUpdated="onPostsUpdated" />
</template>

<script>
import UTILS from '../../utils/utils';
import store from '../../store';
import postPlugin from '../../utils/plugin/postPlugin';
import postDetail from './PostDetail.vue';
import postList from './PostList.vue';
import { getPost, getPostList } from '../../api/post';

export default {
  mixins: [postPlugin],
  components: {
    'post-detail': postDetail,
    'post-list': postList,
  },
  beforeRouteEnter(route, redirect, next) {
    next(vm => {
      vm.getData(route.params.pid, (post, posts) => {
        if (post) {
          var t = vm.postTitle(post);
          UTILS.setDocumentTitle(route, null, t);
        }
        vm.initPost(post, posts);
      });
    });
  },
  beforeRouteUpdate(to, from, next) {
    this.getData(to.params.pid, (post, posts) => {
      if (post) {
        store.commit('PAGE_TITLE', this.postTitle(post));
      }
      this.initPost(post, posts);
      next();
    });
  },
  data: function() {
    return {
      post: null,
      posts: null,
    };
  },
  watch: {
    stateLastRefreshedId(n, o) {
      if (n == this.pid) {
        this.refreshPost(n);
      }
    },
    stateRefreshedAt(n, o) {
      this.refreshList();
      // Also re-pull the open detail post so edits/answers reflect immediately, even when
      // lastRefreshedId did not change (e.g. editing the same post twice).
      if (this.post) {
        this.refreshPost(this.post.id);
      }
    },
  },
  computed: {
    // Current post id from the route. The stateLastRefreshedId watcher compares against this to
    // re-fetch the open detail post after an edit/answer; without it (this.pid === undefined) the
    // detail screen never refreshed and showed stale content until a manual reload.
    pid() {
      return Number(this.$route.params.pid);
    },
    stateLastRefreshedId() {
      return this.$store.state.post.lastRefreshedId;
    },
    stateRefreshedAt() {
      return this.$store.state.post.refreshedAt;
    },
  },
  methods: {
    onPostsUpdated(posts, post) {
      this.posts = posts;
      if (post && this.post && post.id == this.post.id) {
        this.post = post;
      }
    },
    getData(pid, cb) {
      UTILS.startLoading();
      var cbWrap = (post, posts) => {
        UTILS.stopLoading();
        cb(post, posts);
      };

      if (pid) this.getPostData(pid, cbWrap);
      else this.getListData(cbWrap);
    },
    refreshPost(pid) {
      var self = this;
      getPost(pid)
        .then(function(post) {
          self.post = post;
        })
        .catch(function(e) {
          // no user announce (cause maybe deleted).
          console.error(`failed to get post data.`, e);
        });
    },
    getPostData(pid, cb) {
      var self = this;
      $commin.clientdb.getObject('posts', function(posts) {
        if (posts) {
          var replaced = false;
          for (var post of posts) {
            if (post.id == pid) {
              if (self.curCid && post.community_id != self.curCid) return self._toListPage();
              return cb(post, posts);
            }
          }
        }

        getPost(pid)
          .then(function(post) {
            if (self.curCid && post.community_id != self.curCid) return self._toListPage();
            cb(post, []);
            self.refreshList();
          })
          .catch(function(e) {
            self.errGetData();
            self._toListPage();
          });
      });
    },
    refreshList() {
      var self = this;
      getPostList(0)
        .then(function(response) {
          var ps = response || [];
          self.posts = ps;
          self.$store.commit('POST_COUNT_TODO', ps);
          self.$commin.clientdb.putObject('posts', ps);
        })
        .catch(function(e) {
          if (cb) cb();
          console.error('failed to get posts data', e);
          self.errGetData();
        });
    },
    _toListPage() {
      var cid = this.curCid || 0;
      this.$router.push({ name: 'topHome', params: { id: cid } });
    },
    getListData(cb) {
      // use client db only (cliend db will be updated in store modules (post.js))
      var self = this;
      this.$commin.clientdb.getObject('posts', function(posts) {
        if (posts) {
          self.posts = posts.filter(post => {
            return !!self.cMap[post.community_id];
          });
          return cb(null, posts);
        }

        getPostList(0)
          .then(function(response) {
            var ps = response || [];
            cb(null, ps);
            self.$commin.clientdb.putObject('posts', ps);
          })
          .catch(function(e) {
            if (cb) cb();
            console.error('failed to get posts data', e);
            self.errGetData();
          });
      });
    },
    initPost(post, posts) {
      this.post = post;
      this.posts = posts;
    },
  },
};
</script>
